module.exports = __webpack_public_path__ + "img/5bg.e0fb003a.png";